<template>
  <BaseIcon
    :iconUrl="BrandIconLogo"
    :iconWidth="iconWidth"
    :iconHeight="iconHeight"
    :iconColor="iconColor"
  />
</template>

<script setup lang="ts">
import { BaseIcon } from '@paylibs/po-ui-kit'
import BrandIconLogo from '@assets/logos/brand/brand-icon-logo.svg'

const {
  iconWidth = 122,
  iconHeight = 128,
  iconColor = 'var(--BG-First-Level)'
} = defineProps<{
  iconWidth?: number | string;
  iconHeight?: number | string;
  iconColor?: string;
}>()
</script>
